import { buildSplunkUrl } from './build-splunk-url';
import { getSplunkTimeRangeParams } from './get-splunk-time-range-params';

/**
 * Returns a Splunk search URL that filters logs by the provided trace ID,
 * or `undefined` when no trace ID is available.
 *
 * When a `timestamp` is provided, the URL pins an absolute earliest/latest time
 * window around it so the link stays valid beyond the default (relative) time
 * range. Without a timestamp, Splunk's default time picker range applies.
 *
 * @param traceId - The trace ID to search for.
 * @param timestamp - Optional time of the request (ISO 8601 string or epoch ms)
 *   used to anchor the Splunk search window.
 */
export const getSplunkTraceUrl = (
	traceId: string | null | undefined,
	timestamp?: string | number | null,
): string | undefined => {
	if (!traceId) {
		return undefined;
	}

	return buildSplunkUrl(`traceId = "${traceId}"`, getSplunkTimeRangeParams(timestamp));
};
